<div class="login-container ideta-scrollbar">
  <div class="login-card ideta-scrollbar">
    <img class="login-card-logo" src="/assets/img/ideta_logo.png" alt="Ideta" />
    <h1 appProtocolDroid="login.title">
      Welcome back ! <br />
      Break the code barrier
    </h1>
    <form class="login-card-form" (keydown.enter)="loginWithCredentials($event, email.value, password.value)">
      <input class="form-control m-2" type="email" name="Email" placeholder="Email..." [(ngModel)]="emailInput" #email />
      <input class="form-control m-2" type="password" name="Password" placeholder="Password..." #password />
      <span class="login-card-form-error" *ngIf="!!signInError">{{ signInError }}</span>
    </form>
    <button
      type="submit"
      class="btn btn-md btn-primary login-card-btn login-card-form-btn"
      (click)="loginWithCredentials($event, email.value, password.value)"
      appProtocolDroid="login.btn-login"
    >
      log in
      <i class="fas fa-sign-in-alt"></i>
    </button>
    <ng-container *ngIf="isWebMode">
      <span class="login-card-info" appProtocolDroid="login.separator">Or</span>
      <button class="btn login-card-btn login-card-btn-google" (click)="googleAuth()">
        <i class="fab fa-google"></i>
        <span appProtocolDroid="login.btn" [appProtocolDroidParams]="{ name: 'Google' }">Sign in with Google</span>
      </button>
      <button class="btn login-card-btn login-card-btn-microsoft" (click)="microsoftAuth()">
        <i class="fab fa-microsoft"></i>
        <span appProtocolDroid="login.btn" [appProtocolDroidParams]="{ name: 'Microsoft' }">Sign in with Microsoft</span>
      </button>
    </ng-container>
    <div *ngIf="isWebMode" class="login-card-info text-nowrap">
      <span appProtocolDroid="login.dont-have">Don't have an account ? </span>
      <a [href]="signupUrl" target="_blank" appProtocolDroid="login.sign-up">Sign up</a>
    </div>
    <div class="login-card-info text-nowrap">
      <a [href]="forgotPasswordUrl" target="_blank" appProtocolDroid="login.forgot-password">Forgot password ?</a>
    </div>
  </div>
</div>
